// extracted by mini-css-extract-plugin
export default {"appointmentSelect":"LinkedAppointmentSelect_appointmentSelect__hLLwB","textEllipsis":"LinkedAppointmentSelect_textEllipsis__0-bHn"};